import { render, staticRenderFns } from "./ClientAccountDetail.vue?vue&type=template&id=f4e3fbde"
import script from "./ClientAccountDetail.vue?vue&type=script&lang=ts"
export * from "./ClientAccountDetail.vue?vue&type=script&lang=ts"
import style0 from "./ClientAccountDetail.vue?vue&type=style&index=0&id=f4e3fbde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports